<div class="d-flex schedule-container">
  <div class="mrs-table-container" style="width: 30%">
    <div class="table-heading">
      {{ selectedDate | date: 'EEEE, MMMM d, y' }}
    </div>
    <div class="mrs-table-inner-container">
      <div style="max-height: calc(100vh - 360px); overflow-y: scroll;">
        <div *ngIf="teamMembersUnAvailableListScheduleDataSource && teamMembersUnAvailableListScheduleDataSource.data.length > 0">
          <div class="table-heading">
            Unavailable
          </div>
          <table
            mat-table
            aria-label="Elements"
            [dataSource]="teamMembersUnAvailableListScheduleDataSource"
            matSort
            [matSortActive]="initialSort"
            matSortDirection="asc"
            style="width:100%; overflow:hidden;"
          >
            <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.def">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let row" [ngStyle]="column.columnStyles">
                <div class="d-flex align-items-center">
                  <div class="status-indicator-dot" [ngClass]="getUserAvailabilityClass(row)"></div>
                  <div style="flex: 1">
                    <div *ngFor="let rowDef of column.rowDefs">
                      <div [ngClass]="rowDef.className">{{ row[rowDef.dataName] }}</div>
                      <div  class="text-muted small">
                        {{ row.formattedSchedules }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container *ngIf="false">
              <tr mat-header-row *matHeaderRowDef="displayedColumnsDef"></tr>
            </ng-container>
            <tr
              mat-row
              (click)="onRowClicked(row)"
              *matRowDef="let row; columns: displayedColumnsDef;"
              class="row-height"
              [class.disabled-click]="!canRead"
              style="cursor: pointer"
            >
            </tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                <div class="p-4 text-center text-muted">
                  <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
                  <h6>No Team Members Found</h6>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="teamMembersAvailableScheduleDataSource && teamMembersAvailableScheduleDataSource.data.length > 0">
          <div class="table-heading">
            Available
          </div>
          <table
            mat-table
            aria-label="Elements"
            [dataSource]="teamMembersAvailableScheduleDataSource"
            matSort
            [matSortActive]="initialSort"
            matSortDirection="asc"
            style="width:100%; overflow:hidden;"
          >
            <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.def">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let row" [ngStyle]="column.columnStyles">
                <div class="d-flex align-items-center">
                  <div class="status-indicator-dot" [ngClass]="getUserAvailabilityClass(row)"></div>
                  <div style="flex: 1">
                    <div *ngFor="let rowDef of column.rowDefs">
                      <div [ngClass]="rowDef.className">{{ row[rowDef.dataName] }}</div>
                      <div  class="text-muted small">
                        {{ row.formattedSchedules }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container *ngIf="false">
              <tr mat-header-row *matHeaderRowDef="displayedColumnsDef"></tr>
            </ng-container>
            <tr
              mat-row
              (click)="onRowClicked(row)"
              *matRowDef="let row; columns: displayedColumnsDef;"
              class="row-height"
              [class.disabled-click]="!canRead"
              style="cursor: pointer"
            >
            </tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                <div class="p-4 text-center text-muted">
                  <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
                  <h6>No Team Members Found</h6>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="calendar-container">
    <app-team-calendar
      [teamMembers]="schedules"
      [selectedDay]="selectedDate"
      [setSelectedDay]="setSelectedDate"
    >
    </app-team-calendar>
  </div>
</div>